import request from "@/utils/request";

// 实时播报
export const ssbbList = (data) =>
  request({
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    url: "/bigScreen/ssbbList",
    method: "POST",
    data: data,
  });
